<template>
	<div></div>
</template>
<script>
import useStore from 'webmd-cms-store/src/store';


import _pick from 'lodash/pick';

export default {
	name: 'SetRendered',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
	},
	created() {
       this.store = useStore(this.$pinia);
		this.store.cms.UPDATE_STATE({ key: this.chronicId, value: this.data.moduleData });
	},
};
</script>
